function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import wNumb from 'wnumb';
import noUiSlider from 'nouislider';
import { numberFormat, declension } from '../helpers';
var xhr = new XMLHttpRequest();
xhr.open('GET', location.protocol + '//' + location.host + '/ajax/mortgage-list.php', true);
var responseObject;
xhr.onload = function() {
    if (xhr.status >= 200 && xhr.status < 300) {
        responseObject = JSON.parse(xhr.responseText);
        var filter = responseObject.filter;
        var parentElement = document.querySelector('[data-mortgage-price]');
        var childElement = parentElement.querySelector('.range_single');
        var data_flat_price = document.querySelector('[data-flat-price]');
        childElement.setAttribute('data-range', '{"range": {"min": '.concat(filter.priceMin, ', "max": ').concat(filter.priceMax, '}, "start": ').concat(data_flat_price ? data_flat_price.getAttribute('data-flat-price') : '2700000', ', "step": 1000}'));
        var $ranges = document.querySelectorAll('[data-range]');
        window.ranges = [];
        if ($ranges.length) {
            var rangeInputs = document.querySelectorAll('input[type="text"]');
            rangeInputs.forEach(function(input) {
                input.addEventListener('input', function(event) {
                    event.target.value = event.target.value.replace(/\D/g, '');
                });
                input.addEventListener('blur', function(event) {
                    updateSliderValue(event);
                    input.style.display = 'none';
                });
                input.addEventListener('keydown', function(event) {
                    if (event.key === 'Enter') {
                        updateSliderValue(event);
                    }
                });
            });
            $ranges.forEach(function($range, index) {
                var attr_range = JSON.parse($range.getAttribute('data-range'));
                var options = attr_range || {};
                var $slider = $range.querySelector('.range__slider');
                var $inputs = $range.querySelectorAll('input');
                var $currentValue = $range.closest('.field__slider').querySelector('[data-range-current]');
                var $currentPostfix = $range.closest('.field__slider').querySelector('[data-range-current-postfix]');
                var formatter = wNumb({
                    decimals: 0
                });
                var sliderOptions = _object_spread_props(_object_spread({}, options), {
                    connect: Array.isArray(options.start) ? true : 'lower',
                    step: 1,
                    format: wNumb({
                        decimals: 0
                    })
                });
                if (!$currentValue) {
                    sliderOptions.tooltips = Array.isArray(options.start) ? [
                        formatter,
                        formatter
                    ] : formatter;
                }
                var range = noUiSlider.create($slider, sliderOptions);
                range.on('update', function(values, handle) {
                    if ($currentValue) {
                        $currentValue.innerHTML = numberFormat(values[handle]);
                        if ($currentPostfix) {
                            $currentPostfix.innerHTML = declension.apply(void 0, _to_consumable_array($currentPostfix.dataset.rangeCurrentPostfix.split(',')).concat([
                                values[handle]
                            ]));
                        }
                    }
                    var closestInput = range.target.closest('.field').querySelector('input[type="text"]');
                    if (closestInput) {
                        closestInput.value = values[handle];
                    }
                    var closestInput1 = $range.closest('.field').querySelector('.range__inputs input[type="text"]');
                    if (closestInput1) {
                        closestInput1.value = values[handle];
                        var event = new Event('change', {
                            bubbles: true,
                            cancelable: true
                        });
                        closestInput1.dispatchEvent(event);
                    }
                    if (range.target.parentElement.classList.contains('inital-payment')) {
                        setTimeout(function() {
                            if (window.hasOwnProperty('searchTab')) {
                                window.searchTab('params');
                            }
                        }, 10);
                        var element = document.querySelector('[data-range-current]');
                        var text = element.textContent;
                        var numbersOnly = text.replace(/\D/g, '');
                        var number = parseInt(numbersOnly, 10);
                        var percent = Math.round(values[0] / number * 100);
                        var elements = document.getElementsByClassName('range__slider-dop');
                        var elementClass = elements[0];
                        elementClass.textContent = "".concat(percent, " %");
                    }
                });
                range.on('change', function(values, handle) {
                    if ($inputs.length) {
                        $inputs[handle].value = values[handle];
                        if ($inputs.length) {
                            $inputs[handle].dispatchEvent(new CustomEvent('change'));
                        }
                    }
                });
                window.ranges.push(range);
            });
            var currentValueElements = document.querySelectorAll('[data-range-current]');
            currentValueElements.forEach(function(element) {
                element.addEventListener('click', function() {
                    var closestInput = element.closest('.field').querySelector('input[type="text"]');
                    if (closestInput) {
                        closestInput.style.display = 'block';
                        closestInput.focus();
                    }
                });
            });
        }
    }
};
function updateSliderValue(event) {
    var inputValue = parseFloat(event.target.value);
    var closestSlider = event.target.closest('.field').querySelector('.range__slider');
    if (closestSlider) {
        var rangeData = JSON.parse(closestSlider.parentElement.dataset.range);
        var min = rangeData.range.min;
        var max = rangeData.range.max;
        var newValue = Math.min(Math.max(inputValue, min), max);
        closestSlider.style.setProperty('--value', newValue);
        closestSlider.noUiSlider.set([
            newValue
        ]);
    }
}
xhr.send();
